import Vue from 'vue'
import Vuex from 'vuex'
import VuePageTransition from 'vue-page-transition'

import device from '@/store/device.js';
import general from '@/store/general.js';
import user from '@/store/user.js';
import product from '@/store/product.js';

Vue.use(Vuex)
Vue.use(VuePageTransition)

// Use modules for the Store instead of having all properties in one store
const store = new Vuex.Store({
  modules: {
    device: device,
    general: general,
    user: user,
    product: product,
  },
  // strict: debug
})

export default store;


// Init gsap plugins
import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

window.gsap = gsap;
